"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _imask = _interopRequireDefault(require("imask"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomRangeMask = /*#__PURE__*/function (_IMask$MaskedRange) {
  (0, _inherits2.default)(CustomRangeMask, _IMask$MaskedRange);

  var _super = _createSuper(CustomRangeMask);

  function CustomRangeMask() {
    (0, _classCallCheck2.default)(this, CustomRangeMask);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CustomRangeMask, [{
    key: "doPrepare",
    value: // Custom logic derived from doPrepare method of MaskedRange class:
    // https://github.com/uNmAnNeR/imaskjs/blob/master/packages/imask/src/masked/range.js
    function doPrepare(char, flags) {
      var str = (this.prepare ? this.prepare(char, this, flags) : char).replace(/\D/g, '');
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var val = this.value;
      var prepStr = '';

      for (var ci = 0; ci < str.length; ci += 1) {
        var nextVal = val + prepStr + str[ci];

        var _this$boundaries = this.boundaries(nextVal),
            _this$boundaries2 = (0, _slicedToArray2.default)(_this$boundaries, 2),
            minstr = _this$boundaries2[0],
            maxstr = _this$boundaries2[1]; // Special case for February


        if (/^02\//.test(this.parent.value) && nextVal === '3') {
          this.parent.queue += '3';
          prepStr += '0';
        } else if (Number(maxstr) < this.from) {
          prepStr += fromStr[nextVal.length - 1];
        } else if (Number(minstr) > this.to) {
          if (fromStr.length === 2) {
            // Month or day
            if (!this.isComplete) {
              this.parent.queue += str;
            }

            prepStr += '0';
          } else if (nextVal.length === 1) {
            // Year
            this.parent.queue += "9".concat(str);
            prepStr += '1';
          }
        } else {
          prepStr += str[ci];
        }
      }

      return prepStr;
    }
  }]);
  return CustomRangeMask;
}(_imask.default.MaskedRange);

var _default = CustomRangeMask;
exports.default = _default;
